import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { ReactComponent as AddPlaylistIcon } from "../../../assets/Icons/addtoplaylist.svg";
import { ReactComponent as StreakIcon } from "../../../assets/Icons/lightning.svg";
import ListView from "./ListView";
import Translate from "../../../Components/Multilanguage/Translate";

const MonthlyView = ({
  events,
  date,
  onDateChange,
  onDeleteVideo,
  onVideoComplete,
  appInfo,
  setShowAddVideoModal,
  user,
  redirectToLogin,
  loading,
  userStreak,
  setShowStreakModal,
  pdfUrl,
  pdfTitle,
  onDownloadPdf,
}) => {
  const [selectedDate, setSelectedDate] = useState(date);
  const [calendarKey, setCalendarKey] = useState(
    date.getMonth() + "-" + date.getFullYear()
  );

  useEffect(() => {
    setSelectedDate(date);
    setCalendarKey(date.getMonth() + "-" + date.getFullYear());
  }, [date]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    onDateChange(date);
  };
  
  const formatDateString = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  
  const isDateWatched = (date) => {
    if (!events) return false;
    
    const dateStr = formatDateString(date);
    
    const eventsForDate = events.filter(event => 
      event.dateString === dateStr
    );
    
    return eventsForDate.some(event => event.watched);
  };

  const isDateStrike = (date) => {
    if (!events) return false;
    
    const dateStr = formatDateString(date);
    
    const eventsForDate = events.filter(event => 
      event.dateString === dateStr
    );
    
    return eventsForDate.some(event => event.isBreak);
  };
  
  const getEventsForDate = (date) => {
    if (!events) return [];
    
    const dateStr = formatDateString(date);

    return events.filter(event => 
      event.dateString === dateStr && 
      event.id !== undefined
    );
  };

  const tileContent = ({ date, view }) => {
    if (view === "month") {
      const dayEvents = getEventsForDate(date);
      if (dayEvents.length === 0) return null;
      return (
        <div className="dots-container">
          <span
            className={`dot`}
          ></span>
        </div>
      );
    }
    return null;
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    <div className="monthly-view-container">
      <div className="calendar-section">
        <Calendar
          key={calendarKey}
          value={selectedDate}
          onChange={handleDateChange}
          tileContent={tileContent}
          showNavigation={false}
          locale="en-US"
          tileClassName={({ date, view }) => {
            if (view === "month") {
              const currentMonth = selectedDate.getMonth();
              const day = date.getDay();
              const hasEvents = getEventsForDate(date).length > 0;
              const isWatched = isDateWatched(date);
              const isStrike = isDateStrike(date);
              const isCurrentDay = date.toDateString() === new Date().toDateString();

              let className = ( date.getMonth() === currentMonth && !isWatched && !isStrike ) ? "normal " : "";
           
              if (
                date.getMonth() === currentMonth &&
                (day === 0 || day === 6)
              ) {
                className += "holiday ";
              }

              if (hasEvents) {
                className += "has-events ";
              }
              
              if (isStrike) {
                if (date.getMonth() !== currentMonth) {
                  className += "strike-outside-month ";
                } else {
                  className += "strike-date ";
                }
              }
              else if (isWatched) {
                if (date.getMonth() !== currentMonth) {
                  className += "watched-outside-month ";
                } else {
                  className += "watched-date ";
                }
              }
              
              if (isCurrentDay && isWatched) {
                className += "watched-current-date ";
              }

              if (isCurrentDay && isStrike) {
                className += "strike-current-date ";
              }

              return className.trim() || null;
            }
            return null;
          }}
        />
      </div>
      {user && userStreak && userStreak.current_streak && (
        <button
          className="mobile-streak-btn"
          onClick={() => setShowStreakModal(true)}
        >
          <StreakIcon className="streak-icon" />
          <span>Current streak {userStreak.current_streak} {userStreak.current_streak === '1' ? "day" : "days"}</span>
        </button>
      )}
      {user && pdfUrl && (
        <button
          className="mobile-pdf-download-btn"
          onClick={onDownloadPdf}
        >
          <div className="pdf-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7,10 12,15 17,10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
          </div>
          <span>{(pdfTitle || 'PDF').length > 40 ? `${(pdfTitle || 'PDF').substring(0, 40)}...` : (pdfTitle || 'PDF')}</span>
        </button>
      )}
      {
        date.setHours(0, 0, 0, 0) >= today.getTime() && (
          <button
          className="add-video-btn"
          onClick={() => {
            if (!user) {
              redirectToLogin();
            } else {
              setShowAddVideoModal(true);
            }
          }}
        >
          <AddPlaylistIcon /> <Translate textKey={"add_video"} />
        </button>
        )
      }
      <div className="list-section">
        <ListView
          events={getEventsForDate(selectedDate)}
          date={selectedDate}
          calendarView={true}
          onDeleteVideo={onDeleteVideo}
          onVideoComplete={onVideoComplete}
          appInfo={appInfo}
          user={user}
          redirectToLogin={redirectToLogin}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default MonthlyView;
